import ExtraData from '@/models/ExtraData';

export default class ExtraDataUtils {
  public static getValue(extraData: ExtraData[], key: string): string | null {
    if (!extraData) {
      throw new Error('No ExtraData provided');
    }

    const extraDataItem = extraData.find((x) => x.keyName.toLowerCase() === key.toLowerCase());

    if (!extraDataItem) {
      return null;
    }

    return extraDataItem.keyValue;
  }
}
